import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {PaymentMethodEnum} from "../../../enums/payment-method.enum";
import {OrderService} from "../../../services/order/order.service";
import {PayBillModel} from "../../../models/orders/pay-bill.model";
import {Subject, takeUntil} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();

  public orderBillId: string;
  public venueId: string;
  public orderBillNumber: string;
  public totalPriceWithoutTax: number;
  public totalPriceWithTax: number;
  public currencySymbol: string;
  public currencyShortName: string;
  public paymentMethod: PaymentMethodEnum;
  public paymentMethodEnum: typeof PaymentMethodEnum = PaymentMethodEnum;

  public finishedPaying: boolean = false;
  public tenderAmount: number;
  public toReturn: number = 0;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public translate: TranslateService,
    private messageService: MessageService,
    private orderService: OrderService,

  ) {
    if (this.config.data != undefined) {
      this.orderBillId = this.config.data.orderBillId;
      this.venueId = this.config.data.venueId;
      this.orderBillNumber = this.config.data.orderBillNumber;
      this.currencySymbol = this.config.data.currencySymbol;
      this.currencyShortName = this.config.data.currencyShortName;
      this.totalPriceWithoutTax = this.config.data.totalPriceWithoutTax;
      this.totalPriceWithTax = this.config.data.totalPriceWithTax;
    }
  }

  ngOnInit(): void {
  }

  public choosePaymentMethod(method: PaymentMethodEnum){
    this.paymentMethod = method;
  }
  public finishPaying(){
    if(this.paymentMethod == this.paymentMethodEnum.Cash){
      this.toReturn = this.tenderAmount - this.totalPriceWithTax;
    }
    this.payBill();
    this.finishedPaying = true;
  }
  payBill(){
    let payBillInfo = new PayBillModel();
    payBillInfo.orderBillId = this.orderBillId;
    payBillInfo.venueId = this.venueId;
    payBillInfo.paymentType = this.paymentMethod;
    payBillInfo.amountReceived = this.paymentMethod == this.paymentMethodEnum.Cash ? this.tenderAmount : this.totalPriceWithTax;
    payBillInfo.amountReturned = this.paymentMethod == this.paymentMethodEnum.Cash ? this.toReturn : 0;

    this.orderService.payBill(payBillInfo)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe( response => {
          this.messageService.add({severity:'success', summary: this.translate.instant("ORDER_BILL.SUCCESSFUL_PAYMENT"), life: 3000});
        },
        errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        })
  }

  closeDialog(){
    this.ref.close(null)
  }
  cancel() {
    this.ref.close(null)
  }

}
